export class ToDoModel {
    constructor() {
        this._items = [];
    }
    set items(data) {
        this._items = data;
    }
    get items() {
        return this._items;
    }
    addItem(data) {
        const uniqueId = Math.max(...this._items.map((item) => Number(item.id))) + 1;
        const newItem = { id: String(uniqueId), name: data };
        this._items.push(newItem);
        return newItem;
    }
    removeItem(id) {
        this._items = this.items.filter((item) => item.id !== id);
    }
    getItem(id) {
        return this._items.find((item) => item.id === id);
    }
    editItem(id, name) {
        const editedItem = this._items.find((item) => item.id === id);
        editedItem.name = name;
    }
}
